import getCharts from '../getCharts'
import { GetKeywords } from '../../constants/api.config'

export default async function GetAllKeywords(Mode="SELECT",Keyword = "") {
  try {
    const payload = {Mode,Keyword}
    const res = await getCharts(GetKeywords, payload)
    return res.data
  } catch (error) {
    return error
  }
}
